export default __webpack_public_path__ + "static/media/groupIcon.ad278f7e.svg";